export default "__VITE_ASSET__Czeyzk3P__"